import type { SummarizeStore } from './interfaces'
import type { LessonRecap } from '../types/ai-summarize/interfaces'
import type { ScopeStatus } from '@shared/lib/scope'

import { resolveLessonRecap } from '../../lib/recap'

export const getters = {
  getBookingId: (state: SummarizeStore): SummarizeStore['bookingId'] => state.bookingId,
  getSummaryId: (state: SummarizeStore): SummarizeStore['summaryId'] => state.summaryId,
  getDuration: (state: SummarizeStore): SummarizeStore['duration'] => state.duration,
  getSpeakingTime: (state: SummarizeStore): SummarizeStore['speakingTime'] => state.speakingTime,
  getLessonDate: (state: SummarizeStore): SummarizeStore['lessonDate'] => state.lessonDate,
  getSummary: (state: SummarizeStore): SummarizeStore['summary'] => state.summary,
  getRecap: (state: SummarizeStore): LessonRecap | null => resolveLessonRecap(state.summary),
  // new recap responses come without the legacy title/highlights fields
  isRecap: (state: SummarizeStore): boolean => !state.title && !state.highlights.length,
  getSeekTime: (state: SummarizeStore): SummarizeStore['seekTime'] => state.seekTime,
  getRecordUrl: (state: SummarizeStore): SummarizeStore['recordingUrl'] => state.recordingUrl,
  getTopic: (state: SummarizeStore): SummarizeStore['topic'] => state.topic,
  getHighlights: (state: SummarizeStore): SummarizeStore['highlights'] => state.highlights,
  getRating: (state: SummarizeStore): SummarizeStore['rating'] => state.rating,
  getComment: (state: SummarizeStore): SummarizeStore['comment'] => state.comment,
  getSurvey: (state: SummarizeStore): SummarizeStore['survey'] => state.survey,
  getTitle: (state: SummarizeStore): SummarizeStore['title'] => state.title,
  getHomeActivities: (state: SummarizeStore): SummarizeStore['homeActivities'] => state.homeActivities,
  getHomeTasks: (state: SummarizeStore): SummarizeStore['homeTasks'] => state.homeTasks,
  isShow: (state: SummarizeStore): SummarizeStore['show'] => state.show,
  getStatus: (state: SummarizeStore): ScopeStatus => state.status,
  isLoading: (state: SummarizeStore): boolean => state.status === 'loading',
  isBannerFeedback: (state: SummarizeStore): SummarizeStore['bannerFeedback'] => state.bannerFeedback,
}
